import React from "react";
import ConditionDescriptions from "../../components/common/ConditionDescriptions";
import { termsAndCondition } from "../../components/sections/DataTerms";

const TermsAndCondition = () => {
  return (
    <div className="w-full xl:max-w-1200 mx-auto px-6 mb-[60px]">
      <h1 className="text-4xl md:text-[40px] text-darkBlue lg:text-darkGray font-bold mb-30 mt-10">General Terms & Conditions</h1>
      <div className="flex justify-between items-start mt-16 gap-8">
        <div><ConditionDescriptions content={termsAndCondition}/></div>
        <div className="bg-whiteSmoke/40 p-8 flex-1 lg:block hidden">
          <h4 className="font-bold text-darkBlue lg:text-darkGray mb-4 text-2xl">
            Content
          </h4>
          {termsAndCondition.map((item) => (
            <ul>
              <li className="font-bold text-lg text-darkGray mb-3">{item.section}</li>
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
